import { fromJS } from "immutable";
import types from "./types";

export const initialState = fromJS({
  id: "",
  first_name: "",
  last_name: "",
  isAdmin: false,
});

export default (state = initialState, action) => {
  const type = action.type;

  switch (type) {
    case types.RESET_CURRENT_USER: {
      return initialState;
    }
    default: {
      return state;
    }
  }
};
